"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMessagesWithoutChatId = exports.getMessagesWithChatId = exports.sendMessage = exports.getAllChats = void 0;
const request_1 = __importStar(require("./request"));
const handleError_1 = require("./handleError");
const getAllChats = async () => {
    try {
        const response = await (0, request_1.default)(request_1.GET, `chat/`);
        return response.data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getAllChats = getAllChats;
const sendMessage = async (flightId, receiverId, initiatorId, message) => {
    let param = '';
    if (flightId) {
        param = `?flight_id=` + flightId;
    }
    else if (receiverId && initiatorId) {
        param = `?receiver_id=${receiverId}&initiator_id=${initiatorId}`;
    }
    console.log("sendMessage http");
    try {
        const { data } = await (0, request_1.default)(request_1.POST, `chat/send${param}`, { content: message });
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.sendMessage = sendMessage;
const getMessagesWithChatId = async (chat_id, page) => {
    try {
        const { data } = await (0, request_1.default)(request_1.GET, `chat/${chat_id}${page ? `?page=${page}` : ''}`);
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getMessagesWithChatId = getMessagesWithChatId;
const getMessagesWithoutChatId = async (flightId, receiverId, initiatorId, page) => {
    let param = '';
    if (flightId) {
        param = '?flight_id=' + flightId;
    }
    else if (receiverId && initiatorId) {
        param = `?receiver_id=${receiverId}&initiator_id=${initiatorId}`;
    }
    try {
        const { data } = await (0, request_1.default)(request_1.GET, `chat/messages${param}${page ? `&page=${page}` : ''}`);
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getMessagesWithoutChatId = getMessagesWithoutChatId;
